import styled from 'styled-components';

export const NotesList = styled.ul`
	list-style: none;
	margin: 0 0 1.5rem;
	padding: 0;
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
`;

export const NoteItem = styled.li`
	background: #f8f8f8;
	border: 1px solid #e0e0e0;
	border-radius: 8px;
	padding: 0.75rem 1rem;
`;

export const NoteText = styled.p`
	margin: 0 0 0.5rem;
	font-size: 14px;
	color: #1a1a1a;
	white-space: pre-wrap;
	word-break: break-word;
	text-align: left;
`;

export const NoteMeta = styled.span`
	font-size: 12px;
	color: #757575;
`;

export const NoteActions = styled.div`
	display: flex;
	gap: 0.5rem;
	margin-top: 0.5rem;
	justify-content: flex-end;
`;

export const NoteActionButton = styled.button`
	background: none;
	border: none;
	padding: 0;
	cursor: pointer;
	font-size: 12px;
	color: #757575;

	&:hover {
		color: #1a1a1a;
	}

	&.danger:hover {
		color: #d32f2f;
	}
`;

export const EditTextarea = styled.textarea`
	width: 100%;
	box-sizing: border-box;
	min-height: 72px;
	padding: 8px 12px;
	font-size: 14px;
	color: #1a1a1a;
	background: #ffffff;
	border: 1px solid #e0e0e0;
	border-radius: 8px;
	resize: vertical;
	font-family: inherit;

	&:focus {
		outline: none;
		border-color: #000000;
		border-width: 2px;
	}
`;

export const AddSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
`;

export const Label = styled.label`
	font-size: 14px;
	font-weight: 500;
	color: #1a1a1a;
`;

export const EmptyState = styled.p`
	font-size: 14px;
	color: #757575;
	text-align: center;
	margin: 0 0 1.5rem;
`;
